import React from 'react';
import {
    Page,
    Card,
    ResourceItem,
    ResourceList,
    Stack,
    Layout,
    Heading,
    TextStyle,
    Banner,
    Button,
} from '@shopify/polaris';
import { useHistory } from "react-router-dom";
import { Helmet } from 'react-helmet';

const AvailableValidationRules = [
    {
        name: "Validate Product Tags In A Smart Collection",
        description: "Validate products in a smart collection contain required tags",
        type: "SmartCollectionProductTagsValidation",
        inProgress: false
    },
]

function ValidationRulesCreatePage() {

    const history = useHistory();
    return (
        <div>
            <Helmet>
                <title>Tag Genie - Create Validation Rule</title>
            </Helmet>
            <Page title="Create Validation Rule"
                breadcrumbs={[{ content: 'Validation Rules', url: '/validation-rules' }]}>
                <Layout>
                    <Layout.Section>
                        <Card title="Available Rules" >
                            <ResourceList
                                selectable={false}
                                resourceName={{ singular: 'rules', plural: 'rules' }}
                                items={AvailableValidationRules}
                                renderItem={renderAvailableRuleItem}
                            />
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <Banner
                            title="Missing a rule you need?"
                            action={{ content: 'Chat with us', onAction: requestRule }}
                            status="info"
                        >
                            <p>If you need a rule that seems to be missing, chat with us so that we can implement it.</p>
                        </Banner>
                    </Layout.Section>
                </Layout>
            </Page>
        </div >
    );

    function addRule(ruleType) {
        history.push(`/validation-rules/create/${ruleType}`);
    }

    function requestRule(ruleType) {
        window.$crisp.push(["do", "chat:open"]);
    }

    function renderAvailableRuleItem(item) {
        const { type, name, description, inProgress } = item;

        var heading = <Heading>{name}</Heading>;
        var details = <span>{description}</span>;
        var button = <Button primary onClick={() => addRule(type)}>{"Create Rule"}</Button>

        if (inProgress) {
            heading = <Heading><TextStyle variation="subdued">{name}</TextStyle></Heading>;
            details = <TextStyle variation="subdued"><span>{description}</span></TextStyle>;
            button = <Button onClick={() => requestRule(type)}>Available Soon - Click to Request</Button>
        }

        return (
            <ResourceItem id={type} url={null} verticalAlignment="center">
                <Stack wrap={false}>
                    <Stack.Item fill>
                        {heading}
                        {details}
                    </Stack.Item>
                    <Stack.Item>
                        {button}
                    </Stack.Item>
                </Stack>
            </ResourceItem >
        );
    }
}

export default ValidationRulesCreatePage;